import ApiService from '@/services/api.service'

const CguService = {

	/**
	 * Retourne le teste de la dernière version des CGU
	 */
	getLast: async function() {
		const response = await ApiService.get('/api/cgu')
		return response.data
	},

	/**
	 * Accepte les CGU
	 */
	accept: async function(cguId) {
		const response = await ApiService.post('/api/cgu/' + cguId)
		return response.data
	},

	/**
	 * Téléchargement des acceptations des CGU
	 */
	downloadCSV: async function() {
		ApiService.download('/file/cgu-csv', 'cgu-acceptations.csv');
	}
}

export default CguService